<form [formGroup]="form" (ngSubmit)="submit()" novalidate class="flex flex-column">

    <div class="flex">
        <div class="col-6">
            Journaux à exporter
        </div>
        <div class="col-6">
            {{ accountEntryExport.journalsDisp }}
        </div>
    </div>

    <div class="flex">
        <div class="col-6">
            Période
        </div>
        @if (!!accountEntryExport.dateFrom) {
        <div class="col-6">
            Du {{ accountEntryExport.dateFrom.toDate() | date:'shortDate' }} au {{ accountEntryExport.dateTo.toDate() |
            date:'shortDate' }}
        </div>
        } @else {
        <div class="col-6">
            Tout
        </div>
        }
    </div>

    <div class="flex">
        <div class="col-6">
            Exporter à nouveau les écritures déjà exportées ?
        </div>
        <div class="col-6">
            @if (accountEntryExport.extracted) {
            Oui
            } @else {
            Non
            }
        </div>
    </div>

    <div class="flex">
        <div class="col-6">
            Format d'export
        </div>
        <div class="col-6">
            <p-select appendTo="body" [options]="exportFormats" dataKey="code" formControlName="format"></p-select>
        </div>
    </div>

    <div class="flex">
        <div class="col-6 col-offset-6">
            <p-checkbox formControlName="attachments" [binary]="true" inputId="attachments" />
            <label for="attachments" class="ml-2">Inclure les pièces jointes ?</label>
        </div>
    </div>

    @if (form.get('attachments')?.value) {
    <div class="flex">
        <div class="col-6 col-offset-6 flex align-items-center">
            <p-checkbox formControlName="compress" [binary]="true" inputId="compress" />
            <label for="compress" class="ml-2">Réduire la taille des pièces jointes ?</label>
            <p-button icon="pi pi-info-circle" type="button" [rounded]="true" [text]="true" size="small"
                (click)="opCompress.toggle($event)"></p-button>
        </div>
    </div>
    }

    <div class="flex">
        <div class="col-6 col-offset-6 flex justify-content-end">
            <p-button label="Lancer l'export" type="submit" icon="pi pi-file-export" severity="success" [rounded]="true"
                [disabled]="form.invalid" [loading]="accountEntryExport.busy"></p-button>
        </div>
    </div>

</form>

<p-popover #opCompress>
    <div class="w-25rem">
        <p>
            Réduit le poids des PDF et des images placés dans l'archive d'export (jusqu'à -90 % sur les photos prises
            depuis l'application mobile), tout en conservant une qualité suffisante pour lire les champs des factures.
        </p>
        <p>
            Les pièces jointes d'origine ne sont pas modifiées : seule la copie ajoutée à l'archive est compressée.
        </p>
    </div>
</p-popover>